import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Center from '../components/home/center'
import './index.css'
import '../components/layout.css'

const IndexPage = (props) => {  
  return (
    <Layout location={props.location}>
      <SEO title='Canopy' />        
        <div className='home'>
          <Center />
        </div>
    </Layout>
  )
}

export default IndexPage